import { html, el } from './html.js';

// Asks before a destructive action. Resolves true only when `word` is pressed.
export function confirmAction(question, word) {
  return new Promise(resolve => {
    const dialog = el(html`<dialog class="confirm">
      <form method="dialog">
        <p>${question}</p>
        <div class="actions">
          <button class="destructive" value="yes">${word}</button>
          <button class="secondary" value="no" autofocus>Cancel</button>
        </div>
      </form>
    </dialog>`);
    document.body.append(dialog);
    dialog.addEventListener('close', () => { dialog.remove(); resolve(dialog.returnValue === 'yes'); });
    dialog.showModal();
  });
}
